var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 146.7 146.7",
    style: {
      enableBackground: "new 0 0 146.7 146.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_00000149359912370594182680000017545149740907805586_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_608",
    className: "st0",
    d: "M78.1,6.1l0.7,2.3c2.2,8.3,10.7,13.3,19.1,11.2c0,0,0,0,0,0c2.4-0.6,4.7-1.9,6.6-3.6 l0.1-0.1c2.3-2,5.7-1.9,7.8,0.4c1.3,1.5,1.8,3.5,1.1,5.4c-2.7,8.3,1.9,17.3,10.2,20c2.4,0.8,4.9,1,7.4,0.6l0,0 c3-0.5,5.8,1.6,6.3,4.6c0.3,1.9-0.4,3.9-1.9,5.1l-0.2,0.1c-6.7,5.6-7.6,15.6-2,22.4c1.6,1.9,3.5,3.3,5.8,4.3l2.2,1 c2.5,1.1,3.6,4.1,2.5,6.6c-0.7,1.5-2.1,2.6-3.7,2.8l-2.6,0.3c-8.6,1.1-14.6,9-13.5,17.6c0.3,2.4,1.2,4.7,2.5,6.7l1.5,2.2 c1.5,2.2,1,5.3-1.3,6.8c-1.4,1-3.3,1.1-4.9,0.4l-2.2-1c-7.8-3.8-17.2-0.5-20.9,7.3c-1.1,2.2-1.6,4.7-1.6,7.2v2.6 c0.1,2.7-2,4.9-4.6,5c-1.8,0.1-3.4-0.8-4.4-2.4l-1.2-2.1c-4.5-7.4-14.1-9.8-21.6-5.3c-2.2,1.3-4,3.2-5.3,5.3l-1.2,1.9 c-1.4,2.3-4.4,3.1-6.7,1.7c-1.5-0.9-2.4-2.6-2.4-4.4v-2.3c0.2-8.7-6.6-15.9-15.3-16.2c0,0,0,0,0,0c-2.5-0.1-5,0.4-7.2,1.5l-2.1,1 c-2.5,1.2-5.4,0.1-6.6-2.3c-0.8-1.6-0.6-3.4,0.4-4.9l1.4-1.9c4.9-7.3,3-17.2-4.3-22.1c-2-1.4-4.4-2.3-6.8-2.6l-2.3-0.3 c-2.7-0.4-4.6-2.9-4.2-5.6c0.2-1.7,1.3-3.2,2.9-3.9l2.1-0.9c8-3.6,11.7-12.9,8.1-21c-1-2.2-2.5-4.2-4.3-5.8l-1.8-1.5 c-2.1-1.8-2.4-4.9-0.6-7c1.1-1.3,2.8-2,4.5-1.7l2.2,0.4c8.6,1.4,16.8-4.5,18.2-13.1c0.4-2.5,0.2-5-0.6-7.4l-0.7-2.1 c-0.9-2.6,0.5-5.3,3-6.2c1.7-0.6,3.6-0.2,5,1.1l1.7,1.5c6.4,5.8,16.3,5.3,22.1-1.1c1.7-1.9,2.9-4.1,3.5-6.5l0.6-2.2 c0.7-2.6,3.4-4.1,6-3.4C76.3,3.2,77.6,4.4,78.1,6.1L78.1,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_610",
    className: "st0",
    d: "M116.9,73.2c0.1,14.1-6.6,27.3-18,35.6c-15.2,11.1-35.9,11.1-51.1,0 c-19.8-14-24.4-41.3-10.5-61.1s41.3-24.4,61.1-10.5C110.1,45.5,117,58.9,116.9,73.2L116.9,73.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_613",
    className: "st0",
    d: "M46.1,75l20.7,23.4l32.8-38.7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBlack);
export default __webpack_public_path__ + "static/media/checkBlack.c639390b181de4c4889571f06685f5f6.svg";
export { ForwardRef as ReactComponent };